import type { SVGProps } from 'react';

const SvgNavigationEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 11" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2.1 0C.94 0 0 .923 0 2.063v6.874C0 10.078.94 11 2.1 11h9.795c1.16 0 2.1-.922 2.1-2.061L14 2.064C14 .924 13.06 0 11.9 0zm-.7 2.063c0-.38.314-.688.7-.688h9.8c.387 0 .7.308.7.688v.1l-.004-.006L7 5.39 1.405 2.157l-.005.009zm0 1.687v5.188c0 .38.314.687.7.687h9.795c.386 0 .7-.307.7-.687l.004-5.187L7 6.985z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgNavigationEmail;
